import React, { Component } from "react"
import TableNotificacao from "./TableNotificacao"
import Layout from "../../Layout"
import { Loading, HttpError } from "../../../components"
import * as ApiHelper from "../../../ApiHelper"
import Moment from "moment"
export default class Notificacao extends Component {
  constructor() {
    super()
    this.getSolicitacoes = this.getSolicitacoes.bind(this)
    this.didDelete = this.didDelete.bind(this)
    this.filter = this.filter.bind(this)
    this.state = { solicitacoes: [], initialSolicitacoes: [], showTable: false }
  }
  componentWillMount() {
    this.getSolicitacoes()
  }
  getSolicitacoes() {
    ApiHelper.getSolicitacoesEsclarecimentos((solicitacoes, error) => {
      if (solicitacoes) {
        this.setState({
          solicitacoes: solicitacoes,
          initialSolicitacoes: solicitacoes,
          showTable: true
        })
      } else {
        this.setState({
          httpError: error
        })
      }
    })
  }
  filter(event) {
    var searchText = event.target.value.toLowerCase()
    var filtered = this.state.initialSolicitacoes.filter(solicitacao => {
      var containsSearchText = false
      solicitacao.pendencias.forEach(pendencia => {
        if (containsSearchText === false) {
          containsSearchText =
            pendencia.pendencia.toLowerCase().search(searchText) !== -1 ||
            pendencia.ref_contratual.toLowerCase().search(searchText) !== -1
        }
      })
      return (
        Moment(solicitacao.created_at)
          .format("D/MM/Y")
          .toLowerCase()
          .search(searchText) !== -1 ||
        solicitacao.contrato.num_contrato.toLowerCase().search(searchText) !==
          -1 ||
        containsSearchText
      )
    })
    this.setState({
      solicitacoes: filtered
    })
  }
  didDelete() {
    this.getSolicitacoes()
  }
  render() {
    if (this.state.httpError) {
      return (
        <Layout tabActive="Fiscalização">
          <HttpError
            message={this.state.httpError.message}
            status={this.state.httpError.status}
          />
        </Layout>
      )
    }
    return (
      <Layout tabActive="Fiscalização">
        {this.state.showTable ? (
          <TableNotificacao
            filter={this.filter}
            onDelete={this.didDelete}
            sizeClass=""
            title="Notificações"
            subtitle="Listagem das Notificações"
            backgroundColor="as-blue"
            rows={this.state.solicitacoes}
          />
        ) : (
          <Loading />
        )}
      </Layout>
    )
  }
}



// WEBPACK FOOTER //
// ./src/views/fiscalizacao/notificacao/Notificacao.js